<div class="flex flex-col -mt-0 xs:-mt-10 2xs:mt-10 sm:mt-5 sm:-mt-8 md:-mt-15">
  <div class="w-full">
    <svg viewBox="0 0 500 60" preserveAspectRatio="none" class="h-full w-full">
      <path d="M-0.00,28.38 C239.65,7.49 257.71,39.33 503.76,25.39 L501.12,77.16 L-0.00,79.16 Z" style="stroke: none; fill: #000000;">
      </path>
    </svg>
  </div>
</div>
<div class="w-full h-45 lg:h-55 bg-theme-black digits-panel flex flex-row -mt-1 lg:-mt-12 text-center pl-5 pr-5 lg:pl-10 lg:pr-10 ">
  <div *ngFor="let digit of digits" class="text-white mb-10 pl-2 pr-2 lg:pl-5 lg:pr-5 flex-1 hidden sm:block">
    <app-lp-icon [icon]="digit.icon" color="white"></app-lp-icon>
    <p class="text-center font-theme-source mb-1 md:mb-2 block text-2xl xs:text-2xl max-xs:text-2xl sm:text-3xl md:text-3xl lg:text-4xl xl:text-4xl 2xl:text-5xl font-bold text-white mt-4">
      {{digit.title}}
      <span class="text-center font-theme-source text-sm sm:text-md md:text-md lg:text-lg xl:text-lg text-white font-medium mt-2">{{digit.text}}</span>
    </p>

  </div>

  <div class="swiper digits-carousel swiper-container w-full -mt-4 sm:-mt-0" *ngIf="window.innerWidth <= 640">
    <div class="swiper-wrapper">
      <div *ngFor="let digit of digits" class="text-white mb-10 pl-2 pr-2 lg:pl-5 lg:pr-5 swiper-slide">
        <app-lp-icon [icon]="digit.icon" color="white"></app-lp-icon>
        <p class="text-center font-theme-source mb-1 md:mb-2 block text-2xl xs:text-4xl sm:text-3xl md:text-3xl lg:text-4xl xl:text-4xl 2xl:text-5xl font-bold text-white mt-4">
          {{digit.title}}
          <span class="text-center font-theme-source text-lg sm:text-md md:text-md lg:text-lg xl:text-lg text-white font-normal mt-2">{{digit.text}}</span>
        </p>
      </div>
    </div>
  </div>

</div>

